//
// Equipment Filter
// --------------------------------------------------
// Client-side filtering for equipment category pages
// Filters equipment items based on subcategory selection without page refresh

window.addEventListener('load', () => {
    const select = document.getElementById('subcategory-filter');
    if (!select) return;

    const equipmentItems = document.querySelectorAll('.equipment-item');
    const countNumber = document.getElementById('count-number');
    const countPlural = document.getElementById('count-plural');
    const activeCategoryName = document.getElementById('active-category-name');
    const equipmentGrid = document.getElementById('equipment-grid');
    const noResults = document.getElementById('no-results');

    const filterEquipment = () => {
        const selectedValue = select.value;
        const selectedOption = select.options[select.selectedIndex];
        const categoryName = selectedOption.dataset.categoryName;
        let visibleCount = 0;

        // Update URL without page refresh
        const url = new URL(window.location.href);
        if (selectedValue) {
            url.searchParams.set('subcategory', selectedValue);
        } else {
            url.searchParams.delete('subcategory');
        }
        window.history.pushState({}, '', url);

        // Filter equipment items
        equipmentItems.forEach((item) => {
            const categories = item.dataset.categories.split(',');

            if (!selectedValue || categories.includes(selectedValue)) {
                item.style.display = '';
                visibleCount++;
            } else {
                item.style.display = 'none';
            }
        });

        // Update results count
        countNumber.textContent = visibleCount;
        countPlural.textContent = visibleCount !== 1 ? 's' : '';
        activeCategoryName.textContent = categoryName;

        // Show/hide no results message
        if (visibleCount === 0) {
            equipmentGrid.classList.add('hidden');
            noResults.classList.remove('hidden');
        } else {
            equipmentGrid.classList.remove('hidden');
            noResults.classList.add('hidden');
        }
    };

    select.addEventListener('change', filterEquipment);

    // Trigger filter on page load if there's a subcategory in URL
    const urlParams = new URLSearchParams(window.location.search);
    const subcategoryParam = urlParams.get('subcategory');
    if (subcategoryParam) {
        // Check if this subcategory exists in the dropdown
        const optionExists = Array.from(select.options).some(option => option.value === subcategoryParam);

        if (optionExists) {
            // Valid subcategory for this page - apply the filter
            select.value = subcategoryParam;
            filterEquipment();
        } else {
            // Invalid subcategory for this page - reset to "All" and clean URL
            select.value = '';
            const url = new URL(window.location.href);
            url.searchParams.delete('subcategory');
            window.history.replaceState({}, '', url);
        }
    }
});

